module.exports = __webpack_public_path__ + "img/11_42.7895f750.png";